export const MESSAGE = {
    EMAIL_INVALID: "Please enter valid email address.",
    REQUEIRED_THIS_FIELD: "{0} field is required.",
    INVALID_CONFIRM_PASSWORD: "Confirm Password should be same as Password",
    DOB_INVALID: "Please enter valid Date of Birth.",
    SPACE_NOT_ALLOWED: "Spaces are not allowed.",
    FIELD_INVALID: "Invalid {0} format.",
    INVALID_PHONE: "Invalid {0} format, like: +91 9090909090",

    THIS_REQUEIRED_FIELD: "This field is required.", 
    NEW_PASSWORD_INVALID: "Passwords must contain at least 8 characters, including special character (@,#,&), uppercase, lowercase letters and numbers.",
    CONFIRM_PASSWORD_INVALID: "Confirm Password must be same as New Password",

    FIRST_NAME_SPACE_INVALID: "First name can not have spaces.",
    LAST_NAME_SPACE_INVALID: "Last name can not have spaces.",

    PHONE_INVALID: "Phone number must be of 10 digits.",
    PINCODE_INVALID: "Pincode must be of 6 digits.",
    UPLOAD_IMAGE_FORMAT_LIMIT: "Only png, jpg, jepg are allowed as a profile picture.",
    PROFILE_UPDATED: "Profile pic updated successfully.",

    INVALID_OTP: "Invalid OTP.",
    INVALID_URL: "url link is invalid.",
}